import { calculateWithdrawalFee } from '@/utils/helpers';

const withdrawWarningMixin = {
  data() {
    return {
      isWarningMessage: false,
      warningTitle: '',
      warningBody: '',
    };
  },
  methods: {
    checkWarningFlags(data) {
      this.isWarningMessage = data.isWarningMessage;
      this.warningTitle = data.warningTitle;
      this.warningBody = data.warningBody;
    },
    calculateFee({ amount, feePercent, feeCap }) {
      return calculateWithdrawalFee({ amount, feePercent, feeCap });
    },
  },
};


export default withdrawWarningMixin;



// WEBPACK FOOTER //
// ./src/mixins/withdrawWarning.js